import React from "react";
import { Link } from "react-router-dom";

const services = [
  {
    title: "Web Development",
    image: "/ourservice1.png",
    href: "/aI-based-web-development-services",
  },
  {
    title: "App Development",
    image: "/ourservice2.jpg",
    href: "/aI-based-app-development-services",
  },
  {
    title: "Staffing (India & US)",
    image: "/ourservice3.png",
    href: "/aI-integrated-staffing-solutions",
  },
  {
    title: "Digital Marketing",
    image: "/ourservice4.png",
    href: "/glowtech-services",
  },
  {
    title: "SMS & WhatsApp API solutions",
    image: "/ourservice5.jpg",
    href: "/sms-whatsapp-api-solutions",
  }
];

const CoreServicesSection = () => {
  return (
    <div className="px-4 md:px-52 font-poppins">
      <div className="text-center mb-4">
        <h3 className="text-4xl text-[#0D283F] font-bold">Our Core Services</h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-8 gap-x-6">
        {services.map((service, index) => (
          <Link to={service.href} key={index}>
            <div className="bg-transparent hover:bg-white hover:shadow-xl transition-all duration-900 ease-in-out rounded-2xl p-4 flex flex-col items-center text-center">
              <img
                src={service.image}
                alt={service.title}
                className="w-60 h-60 object-contain mb-4"
              />
              <p className="text-xl font-semibold text-[#0D283F]">
                {service.title}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CoreServicesSection;
